
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { HeadMeta } from '@/components/Molecules/HeadMeta/HeadMeta';
import { ForbiddenPage } from '@/components/Pages/Errors/ForbiddenPage';
import type { INewsContentProps } from '@/components/Pages/News/NewsRsfPage';
import { NewsRsfPage } from '@/components/Pages/News/NewsRsfPage';
import { getAnalyticsData, getBaseAnalytics } from '@/components/Templates/InfiniteScrollPage/InfiniteScrollPage';
import { BaseAppContextContainer } from '@/contexts/AppContext/AppContextContainer';
import { getAppContextServerSideProps } from '@/contexts/AppContext/AppContextServer';
import { ContentType } from '@/interfaces';
import { getPublicMetadataForTerminalContent } from '@/services/TerminalContent';
const getServerSideProps = getAppContextServerSideProps(async ({ query, res, api }) => {
    const apiQuery: any = {};
    const storyLanguage = query?.language?.toString();
    if (storyLanguage) {
        apiQuery.translationLanguageTarget = storyLanguage.toLowerCase();
    }
    try {
        const data = await api.get({
            path: '/news_stories/[ID]',
            replacements: { id: query.id as string },
            query: apiQuery,
        });
        if (data?.canonicalResource) {
            let url = data.canonicalResource.url;
            if (storyLanguage) {
                url += `?language=${storyLanguage}`;
            }
            return { redirect: { destination: url, statusCode: 301 } };
        }
        if (data?.newsStory) {
            api.post({
                path: '/users/content_view',
                body: { contentId: data.newsStory.id, contentType: ContentType.news },
            }).catch(() => { });
            return {
                props: {
                    analyticsMetadata: getAnalyticsData(ContentType.news, data.newsStory.id),
                    ...data,
                },
            };
        }
    }
    catch (e) {
        const acceptableHttpErrors = [403];
        if (e.hasOwnProperty('response') && acceptableHttpErrors.includes(e?.response?.status)) {
            res.statusCode = e.response.status;
            return {
                props: { analyticsMetadata: getBaseAnalytics(ContentType.news), responseCode: e.response.status },
            };
        }
        throw e;
    }
    return { notFound: true };
}, getPublicMetadataForTerminalContent);
export default class extends BaseAppContextContainer<INewsContentProps & {
    responseCode?: number;
}> {
    public render() {
        if (this.props?.responseCode === 403) {
            return <ForbiddenPage />;
        }
        return (<>
                <HeadMeta title={this.props.newsStory.title} type={ContentType.news} image={this.props.newsStory.leadImage?.baseUrl} publishDate={this.props.newsStory.displayDate} tags={this.props.newsStory.tags}/>
                <NewsRsfPage newsStory={this.props.newsStory} relatedStories={this.props.relatedStories} translationLocales={this.props.translationLocales}/>
            </>);
    }
}

    async function __Next_Translate__getServerSideProps__1a168617301__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a168617301__ as getServerSideProps }
  